import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/configProbe/upsert/uptime.configProbe.upsert.mutation.gql"
import type {
  UptimeConfigProbeUpsertMutation,
  UptimeConfigProbeUpsertMutationVariables,
} from "@/v2-backoffice-client/uptime/configProbe/upsert/__types__/uptime.configProbe.upsert.mutation"

type Options = MutationHookOptions<
  UptimeConfigProbeUpsertMutation,
  UptimeConfigProbeUpsertMutationVariables
>

// useUptimeConfigProbeUpsertMutation writes an editorial probe
// row. The Probes tab refetches the cursor-paginated list query
// after a successful save so the new row shows up at the top
// (the table sorts on Identifier asc by default).
export function useUptimeConfigProbeUpsertMutation(options?: Options) {
  return useMutation<
    UptimeConfigProbeUpsertMutation,
    UptimeConfigProbeUpsertMutationVariables
  >(mutation, {
    refetchQueries: ["UptimeConfigProbeListQuery"],
    awaitRefetchQueries: true,
    ...options,
  })
}
